/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StatusType {
  Active = 'Active',
  Inactive = 'Inactive',
  ReleasedFromCare = 'ReleasedFromCare',
  Deceased = 'Deceased'
}
